import { Grid, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  deleteFailedMsg,
  deletemsg,
  deleteWarningMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { ButtonCompo } from "../../components/Comman/Button";
import { batchwiseManageStockJSON } from "../../DynamicFormsJson/Transaction/batchwiseManageInstock";
import { getCategoryForStakeholder } from "../../Slice/category.slice";
import { getProductByCategoryForStakeHolder } from "../../Slice/product.slice";
import { getItemwiseBatch } from "../../Slice/manageStock.slice";
import {
  getManageStockById,
  setManageStockDetails,
} from "../../Slice/manageStock.slice";
import { apiDelete, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import MaterialUITableWithTextField from "../../components/Comman/RT/MaterialUITableWithTextField";

class ManageInStockEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        categoryDetail: this.props.categoryList.categoryForStakeholder,
        productDetail: this.props.productList.productByCategoryForStakeholder,
        batchDetail: this.props.batchList.itemwiseBatchData,
      },

      headerData: {},
      DataToSet: [],
      historyData: {},
    };
  }

  async componentDidMount() {
    const {
      getManageStockById,
      showLoador,
      showNotification,
      getCategoryForStakeholder,
    } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        await getManageStockById({
          managestockHeaderId: this.props.params.id,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              headerData: response,
              DataToSet: [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Consumption No",
                  value:
                    response.consumptionNo !== null
                      ? response.consumptionNo
                      : "",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Date",
                  value: response.date !== null ? response.date : "",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Type",
                  value:
                    response.type !== null
                      ? response.type === 0
                        ? "Out-Stock"
                        : "In-Stock"
                      : "",
                },
              ],
            });
          }
        });

        showLoador({ loador: true });
        await getCategoryForStakeholder().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.categoryList.categoryForStakeholder !==
      nextProps.categoryList.categoryForStakeholder
    ) {
      this.setState({
        dynamicMasterData: {
          ...this.state.dynamicMasterData,
          categoryDetail: nextProps.categoryList.categoryForStakeholder,
        },
      });
    }
    if (this.props.productList !== nextProps.productList) {
      if (
        this.props.productList?.productByCategoryForStakeholder !==
        nextProps.productList?.productByCategoryForStakeholder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            productDetail:
              nextProps.productList?.productByCategoryForStakeholder,
          },
        });
      }
    }
    if (this.props.batchList !== nextProps.batchList) {
      if (
        this.props.batchList.itemwiseBatchData !==
        nextProps.batchList.itemwiseBatchData
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            batchDetail: nextProps.batchList.itemwiseBatchData,
          },
        });
      }
    }
  }

  getListById = async (data) => {
    const {
      getProductByCategoryForStakeHolder,
      getItemwiseBatch,
      showLoador,
      showNotification,
    } = this.props;
    if (navigator.onLine) {
      if (data.category) {
        showLoador({ loador: true });
        await getProductByCategoryForStakeHolder({
          categoryId: data.category,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.product && this.state.headerData) {
        showLoador({ loador: true });
        await getItemwiseBatch({
          orderDate: this.state.headerData.date,
          productId: data.product,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
          }
        });
      }
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  };

  getDataForDisabled = (value) => {
    const { dynamicMasterData } = this.state;
    const { manageStockList } = this.props;
    let productList = dynamicMasterData["productDetail"]
      ? dynamicMasterData["productDetail"].filter((row) => row.id == value)
      : [];
    let batchList = dynamicMasterData["batchDetail"]
      ? dynamicMasterData["batchDetail"].filter((row) => row.id == value)
      : [];
    if (batchList.length != 0) {
      let newBatchList =
        manageStockList.manageStockById.stockStakeHolderConsumptionDetails.filter(
          (row) => row.batchCode == batchList[0].id
        );
      if (newBatchList.length != 0) {
        let newBatchQty = 0;
        newBatchList.map((row) => {
          newBatchQty = newBatchQty + +row.qty;
        });
        return {
          primaryClosingQty: (
            +batchList[0].primaryClosingQty - newBatchQty
          ).toString(),
          batchQty: batchList.length != 0 && batchList[0].primaryClosingQty,
        };
      }
      return {
        primaryClosingQty:
          batchList.length != 0 && batchList[0].primaryClosingQty,
        batchQty: batchList.length != 0 && batchList[0].primaryClosingQty,
      };
    }
    if (productList.length != 0) {
      return {
        rate: productList.length != 0 && productList[0].rate,
        mrp: productList.length != 0 && productList[0].mrp,
        orderQty: productList.length != 0 && productList[0].orderQty,
        uom: productList.length != 0 && productList[0].outletUomName,
        uomConversionValue:
          productList.length != 0 && productList[0].uomConversionValue,
      };
    }
  };
  getDataForCalculate = (value, fieldData) => {
    const { dynamicMasterData } = this.state;
    const { manageStockList } = this.props;
    let batchList = dynamicMasterData["batchDetail"]
      ? dynamicMasterData["batchDetail"].filter(
        (row) => row.id == fieldData.batch
      )
      : [];
    if (
      manageStockList.manageStockById.stockStakeHolderConsumptionDetails
        .length != 0
    ) {
      let newQty = fieldData.batchQty;
      manageStockList.manageStockById.stockStakeHolderConsumptionDetails.map(
        (row) => {
          if (row.batch == fieldData.batch) {
            if (batchList.length != 0 && fieldData.batch) {
              let newBatchList = batchList.filter(
                (rowData) => rowData.id == row.batch
              );
              if (newBatchList.length != 0) {
                newQty = newQty - +row.qty;
              }
            }
          }
        }
      );
      return {
        primaryClosingQty: (+newQty - +value).toString(),
        primaryQty: newQty,
      };
    } else if (fieldData.batch) {
      if (batchList.length != 0) {
        return {
          primaryClosingQty: (
            +batchList[0].primaryClosingQty - value
          ).toString(),
          primaryQty: +batchList[0].primaryClosingQty,
        };
      }
    }
  };
  onSearchList = (data) => {
    const { productList, manageStockList, showNotification } = this.props;

    if (navigator.onLine) {
      let productName = "";
      let rate = 0;
      let mrp = 0;
      let outLetUom = "";
      let stakeHolderUomName = "";
      let uom = "";
      let uomConversionValue = "";
      productList.productByCategoryForStakeholder.filter((rowData) => {
        if (rowData.id == data.product) {
          productName = rowData.name;
          rate = rowData.rate;
          mrp = rowData.mrp;
          outLetUom = rowData.outletUomName;
          uom = rowData.outletUom;
          stakeHolderUomName = rowData.stakeHolderUomName;
          uomConversionValue = rowData.uomConversionValue;
        }
      });
      let row =
        Object.keys(manageStockList.manageStockById).length != 0
          ? manageStockList.manageStockById.stockStakeHolderConsumptionDetails
          : [];

      let dataToSave = {
        index: row.length + 1,
        productName: productName,
        stakeHolderUomName: stakeHolderUomName,
        product: { id: data.product },
        mrp: "",
        type: 0,
        stockType: 0,
        rate: rate,
        qty: data.qty,
        batchCode: "",
        totalAmt: (+rate * +data.qty).toFixed(2),
      };

      row = [...row, dataToSave];
      this.setListDetails({
        row: row,
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  onSubmit = () => {
    const { manageStockList } = this.props;
    let error = false;
    const rowList = {
      ...manageStockList.manageStockById,
      stockStakeHolderConsumptionDetails:
        manageStockList.manageStockById.stockStakeHolderConsumptionDetails.map(
          (rowObj) => {
            if (rowObj.qty.toString() == "") {
              error = true;
            }
            rowObj = {
              ...rowObj,
              qtyError: rowObj.qty.toString() == "" ? 1 : 0,
            };
            return rowObj;
          }
        ),
    };
    this.props.setManageStockDetails({ row: rowList });
    if (!error) {
      swal({
        title: "Are you sure?",
        text: saveWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.onSave(manageStockList.manageStockById);
        }
      });
    }
  };
  onSave = (beatNewObjectToSave) => {
    const { showLoador, showNotification } = this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      apiPost({
        url: endpoint.manageStockHeader,
        postBody: beatNewObjectToSave,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          showNotification({ msg: savemsg });
          this.props.navigate(-1);
        } else {
          showNotification({ msg: saveFailedMsg, severity: "error" });
        }
        return success;
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowDelete = (rowData) => {
    const { showNotification, showLoador, manageStockList } = this.props;
    if (rowData.id) {
      swal({
        title: "Are you sure?",
        text: deleteWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          if (navigator.onLine) {
            showLoador({ loador: true });
            await apiDelete({
              url: endpoint.manageStockDetail + "/" + rowData.id,
            }).then(({ data, success }) => {
              showLoador({ loador: false });
              if (data.data.error == false) {
                showNotification({ msg: deletemsg, severity: "success" });
                const rowList =
                  manageStockList.manageStockById.stockStakeHolderConsumptionDetails.filter(
                    (row) => row.index != rowData.index
                  );
                const row = rowList.map((rowListData, index) => {
                  return { ...rowListData, index: index + 1 };
                });
                this.setListDetails({
                  row: row,
                });
              } else {
                showNotification({ msg: deleteFailedMsg, severity: "error" });
              }
            });
          } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
          }
        }
      });
    } else {
      const rowList =
        manageStockList.manageStockById.stockStakeHolderConsumptionDetails.filter(
          (row) => row.index != rowData.index
        );
      const row = rowList.map((rowListData, index) => {
        return { ...rowListData, index: index + 1 };
      });
      this.setListDetails({
        row: row,
      });
    }
  };
  setListDetails = ({ row }) => {
    const { manageStockList, setManageStockDetails } = this.props;

    let data = {
      ...manageStockList.manageStockById,
      stockStakeHolderConsumptionDetails: row,
    };

    setManageStockDetails({ row: data });
  };

  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    const { manageStockList } = this.props;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showSaveBtn={true}
            showSaveBtnMain={false}
            screenTitle={"Edit Manage Out-Stock Details"}
            DataToSet={DataToSet}
            getListById={this.getListById}
            dynamicMasterData={dynamicMasterData}
            fieldMeta={batchwiseManageStockJSON.fieldMetaDetails}
            apiBaseURL={batchwiseManageStockJSON.apiBaseURL}
            saveBtnText={"Add"}
            onSave={this.onSearchList}
            padding={true}
            paddingTop={true}
            resetAfterSave={true}
            showBackToList={true}
            getDataForDisabled={this.getDataForDisabled}
            getDataForCalculate={this.getDataForCalculate}
            showPegination={false}
          />

          <MaterialUITableWithTextField
            tableHead={[
              {
                title: "Sr.No.",
                name: "index",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "center",
              },
              {
                title: "Product Name",
                name: "productName",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "left",
              },
              {
                title: "UOM",
                name: "stakeHolderUomName",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "center",
              },
              {
                title: "Rate",
                name: "rate",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "right",
              },
              {
                title: "Quantity",
                name: "qty",
                placeHolder: "Enter Order Quantity",
                textFieldError: "qtyError",
                error: "Order Quantity",
                textField: true,
                positionCenter: false,
                showInscreen: true,
                alignCenter: "left",
              },
              {
                title: "Total Amount",
                name: "totalAmt",
                positionCenter: false,
                showInscreen: true,
                alignCenter: "right",
              },
              {
                title: "Action",
                name: "total",
                positionCenter: true,
                showInscreen: true,
                alignCenter: "center",
              },
            ]}
            data={
              Object.keys(manageStockList.manageStockById).length != 0
                ? manageStockList.manageStockById
                  .stockStakeHolderConsumptionDetails
                : []
            }
            setList={this.setListDetails}
            isActionColActive={true}
            showHeadDelete={true}
            rowDelete={this.rowDelete}
          />

          <br />

          <br />
          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            rowSpacing={2}
            columnSpacing={{ xs: 12, sm: 6, md: 1 }}
            container
            justifyContent="right"
          >
            <ButtonCompo
              size="medium"
              type="submit"
              variant="contained"
              name="Cancel"
              onClick={() => this.props.navigate(-1)}
            />
            &nbsp;&nbsp;
            <ButtonCompo
              size="medium"
              type="submit"
              variant="contained"
              name="Update"
              onClick={this.onSubmit}
            />
          </Grid>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  categoryList: state.category,
  productList: state.product,
  batchList: state.manageStockByDate,
  manageStockList: state.manageStockByDate,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getCategoryForStakeholder,
  getProductByCategoryForStakeHolder,
  getItemwiseBatch,
  getManageStockById,
  setManageStockDetails,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ManageInStockEdit);
